import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadFile: {
    id: 'uploadFile',
    defaultMessage: 'Upload file',
  },
  upload: {
    id: 'upload',
    defaultMessage: 'Upload',
  },
  dragAndDrop: {
    id: 'dragAndDrop',
    defaultMessage: 'Drag files to upload or',
  },
  browse: {
    id: 'browse',
    defaultMessage: 'browse',
  },
});
